import React, { useContext, useEffect, useState } from 'react'
import '../index.scss'
import { observer } from 'mobx-react'
import Dropdown from '@Components/Selectors/Dropdown'
import { SelectOption } from '@Components/Selectors/Select'
import { setItemToArrayByIndex } from '@App/helpers/work-entities/removers'
import { StoresContext } from '@App/contexts'
import { OptionModel } from '@Entities/lib'
import { WorkModel } from '@Entities/work/work'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'
import { WriterModel } from '@Entities/work/writer-model'

interface WriterCardEditableProps {
    data: WriterModel
    removeFunction?(removingWriter: WriterModel): void
    errorMessage?: string | undefined
}

const WriterCardEditable = ({ data, removeFunction, errorMessage }: WriterCardEditableProps) => {
    const { workStore, libStore } = useContext(StoresContext)
    const [roleCode, setRoleCode] = useState<number | null>(data.roleCode)

    const setWriterToDraft = (currentRoleCode: number | null) => {
        const workDraftFromLocal = workStore.workDraftLocal
        const editingWriterId = data.localId

        if (!workDraftFromLocal || !editingWriterId) {
            return
        }

        const writers = workDraftFromLocal.writers
        const indexOfWriter = writers.map((writer: WriterModel) => writer.localId).indexOf(editingWriterId)
        const updatedWriter: WriterModel = {
            id: data.id,
            ipId: data.ipId,
            localId: data.localId,
            firstName: data.firstName,
            lastName: data.lastName, // REQUIRED FIELD
            ipiNumber: data.ipiNumber,
            roleCode: currentRoleCode,
            writerShare: null, // TODO Hard code, not mvp
        }

        const updatedWritersArray = setItemToArrayByIndex(writers, +indexOfWriter, updatedWriter)

        const updatedOP: OriginalPublisherModel[] = workDraftFromLocal.originalPublishers.map(
            (op: OriginalPublisherModel) => {
                const updatedWr: WriterModel[] = op.writers.map((writer: WriterModel) => {
                    if (writer.localId === updatedWriter.localId) {
                        return {
                            ...writer,
                            roleCode: updatedWriter.roleCode,
                        }
                    } else {
                        return writer
                    }
                })

                return {
                    ...op,
                    writers: updatedWr,
                }
            }
        )

        const updatedWorkDraft: WorkModel = {
            ...workDraftFromLocal,
            writers: updatedWritersArray,
            originalPublishers: updatedOP,
        }

        workStore.setWorkDraftToLocal(updatedWorkDraft)
    }

    const getCurrentRole = (option: SelectOption) => {
        const newRoleCode = +option.id
        setRoleCode(newRoleCode)
        setWriterToDraft(newRoleCode)
    }

    const stepValidator = () => {
        const isValid = !!roleCode
        workStore.setWizardStepValidation(isValid)
    }

    useEffect(() => {
        setWriterToDraft(roleCode)
    }, [])

    useEffect(() => {
        stepValidator()
    })

    const writerRoleOptions: OptionModel[] = libStore.writerRoles

    if (!writerRoleOptions) {
        return null
    }

    return (
        <div className="writer-card">
            <div className="head">
                <p className="bold">
                    <span>{data.firstName}</span> <span>{data.lastName}</span>
                </p>
                <div className="controls">
                    {removeFunction ? (
                        <span className="small-2 medium" onClick={() => removeFunction(data)}>
                            Remove
                        </span>
                    ) : null}
                </div>
            </div>
            <div className="content">
                <p className="small">
                    IPI: <strong>{data.ipiNumber ? data.ipiNumber : ''}</strong>
                </p>
                <div className="edit-area">
                    <div className="writer-role-edit">
                        <Dropdown
                            options={writerRoleOptions}
                            // placeholder={'Writer role'}
                            label="Writer role"
                            mainColor
                            selectedValue={
                                roleCode ? writerRoleOptions.find((option) => +option.id === roleCode) : null
                            }
                            onSelect={getCurrentRole}
                            isSearchable
                            errorMessage={roleCode ? errorMessage : 'Required'}
                            required
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(WriterCardEditable)
